<template>
  <div class="min-h-screen" :class="isDark ? 'bg-gray-900' : 'bg-white'">
    <Header @open-auth="showAuthModal = true" />
    <main class="pt-16">
      <router-view />
    </main>
    <Footer />
    <AuthModal :show="showAuthModal" @close="showAuthModal = false" @success="handleAuthSuccess" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useTheme } from './composables/useTheme'
import { useAuth } from './composables/useAuth'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import AuthModal from './components/AuthModal.vue'

export default {
  name: 'App',
  setup() {
    const { isDark } = useTheme()
    const { initAuth } = useAuth()
    const showAuthModal = ref(false)
    
    onMounted(() => {
      initAuth()
    })
    
    const handleAuthSuccess = () => {
      showAuthModal.value = false
    }
    
    return { isDark, showAuthModal, handleAuthSuccess }
  },
  components: {
    Header,
    Footer,
    AuthModal
  }
}
</script>

<style>
html {
  scroll-behavior: auto;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
